export enum TopicType {
  Public = "Public",
  Private = "Private"
}
